import { ServerTransactionStatus } from '@wix/cashier-common/dist/src/enums/transactions/ServerTransactionStatus';
import { ClientStatus, FailedServerStatus } from '../types/PaymentStatus';

export const isPendingServerStatus = (
  serverStatus: ServerTransactionStatus
): boolean =>
  [
    ServerTransactionStatus.Pending,
    ServerTransactionStatus.PendingMerchant,
    ServerTransactionStatus.PendingBuyer,
    ServerTransactionStatus.Initialized,
    ServerTransactionStatus.Offline,
  ].includes(serverStatus);

export const isSuccessfulServerStatus = (
  serverStatus: ServerTransactionStatus
): boolean =>
  serverStatus === ServerTransactionStatus.Approved ||
  isPendingServerStatus(serverStatus);

export const isInProcessServerStatus = (
  serverStatus: ServerTransactionStatus
): boolean =>
  [
    ServerTransactionStatus.InProcess,
    ServerTransactionStatus.Initialization,
  ].includes(serverStatus);

export const isFailedServerStatus = (
  serverStatus: ServerTransactionStatus
): boolean =>
  (
    [
      ServerTransactionStatus.Undefined,
      ServerTransactionStatus.Declined,
      ServerTransactionStatus.Failed,
      ServerTransactionStatus.BuyerCanceled,
      ServerTransactionStatus.Timeout,
    ] as FailedServerStatus[]
  ).includes(serverStatus as any);

export const mapServerToClientStatus = (
  serverStatus: ServerTransactionStatus
): ClientStatus => {
  if (serverStatus === ServerTransactionStatus.Approved) {
    return 'Approved';
  }

  if (isPendingServerStatus(serverStatus)) {
    return 'Pending';
  }

  if (isInProcessServerStatus(serverStatus)) {
    return 'InProcess';
  }

  if (isFailedServerStatus(serverStatus)) {
    return 'Failed';
  }

  return 'Unknown';
};
